import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireOnboarding = true }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="font-hand text-xl text-muted">a moment…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarding && !user.onboarding_completed) return <Navigate to="/onboarding" replace />;
  return children;
}
